const prefix = 'PRODUCTS_';

export const ProductsActionTypes = {
  GET_PRODUCT_LIST: `${prefix}GET_PRODUCT_LIST`,
  SET_PRODUCT_LIST: `${prefix}SET_PRODUCT_LIST`,
};

const getProductList = (
  data: {
    pagination?: {
      page?: number
    },
    productFilter?: {
      category?: Array<string> | string,
      brand?: string,
      title?: string,
    },
    sort?: string
  }) => ({ type: ProductsActionTypes.GET_PRODUCT_LIST, data: data });

export const ProductsActions = {
  getProductList: getProductList,
};
